import styled from "styled-components";
import { defaultThemeColors, fonts } from "ui/theme";


export const NoContent = ({
    image,
    title = "No content found",
    size = 180,
}) => {
    return (
        <NoContentContainer $size={size}>
            {image && <div className="imageWrapper"><img src={image} alt="No Content" /></div>}
            <div className="titleText">{title}</div>
        </NoContentContainer>
    );
};

const NoContentContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    height: 100%;
    width: 100%;

    .imageWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: ${({ $size }) => $size}px;
        height: ${({ $size }) => $size}px;
        border-radius: 999px;
        overflow: hidden;

        & > img {
            width: 100%;
            height: 100%;
            aspect-ratio: 1 / 1;
            user-select: none;
        }
    }

    .titleText {
        font-weight: 400;
        font-size: ${fonts.sizes.medium};
        line-height: 130%;
        text-align: center;
        color: ${defaultThemeColors.lightGrey};
    }
`;
